<template>
  <layout-admin current="projects">
    <div class="panel">
      <div class="panel__head">
        <h1>Projects</h1>
        <span>{{ projects.length }}</span>
      </div>

      <div v-if="!projects.length" class="panel__empty">No projects yet.</div>

      <div v-else class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Domain</th>
              <th>Code</th>
              <th>Client</th>
              <th>Commenced</th>
              <th>Active</th>
              <th>Subscriptions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="project in projects" :key="project.id">
              <td>{{ project.domain }}</td>
              <td class="mono">{{ project.code }}</td>
              <td>
                <Link
                  v-if="project.client"
                  :href="route('admin.invoices.index', { client: project.client.id })"
                  class="link"
                >
                  {{ project.client.name }}
                </Link>
                <span v-else>—</span>
              </td>
              <td>{{ formatDate(project.commenced_at) }}</td>
              <td>
                <span class="pill" :class="project.active ? 'is-on' : 'is-off'">
                  {{ project.active ? 'Yes' : 'No' }}
                </span>
              </td>
              <td>{{ project.subscription_count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </layout-admin>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import LayoutAdmin from '@/Layouts/Admin.vue';

export default {
  components: {
    LayoutAdmin,
    Link
  },

  props: {
    projects: { type: Array, required: true }
  },

  methods: {
    formatDate(value) {
      if (!value) return '—';
      const date = new Date(value + 'T00:00:00');
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    }
  }
};
</script>
